/* Ability Warehouse — out-of-hours call handling.
   The status engine + config live inline in snippets/aw-hours.liquid (window.AWHours / window.AW_HOURS) so the header
   label paints before first render. This file adds:
     • tel: interception — when we're CLOSED, a tap on our number opens the "we're closed" sheet instead of dialling
     • the sheet: voicemail recorder (phones/touch only, needs the Web3Forms key), quick email (Shopify contact form),
       and "Chat with us" (Shopify Inbox, only if the widget is on the page)
   Testing: AWHours.setNow('2026-10-28T20:00:00+11:00') fakes the clock; AWHours.setNow(null) restores it.
            window.AW_FORCE_TOUCH = true shows the voicemail recorder on a desktop browser. */
(function () {
  'use strict';
  if (window.AWHoursSheet) return;
  var C = window.AW_HOURS, H = window.AWHours;
  var dlg = document.querySelector('[data-awh]');
  if (!C || !H || !dlg) return;
  var $ = function (s, r) { return (r || dlg).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || dlg).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var telDigits = String(C.tel || '').replace(/\D/g, '').slice(-8); /* 91254293 */
  var MAX = 90; /* seconds */

  /* ---------- helpers ---------- */
  function fmt(s) { s = Math.max(0, Math.round(s)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function isTouchPhone() {
    if (window.AW_FORCE_TOUCH) return true;
    var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
    return mq('(hover: none) and (pointer: coarse)') || /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
  }
  function canRecord() {
    return !!(C.w3f && window.MediaRecorder && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.fetch && window.FormData);
  }
  function chatEl() {
    return document.querySelector('inbox-online-store-chat') || document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
  }
  function openChat() {
    var el = chatEl(); if (!el) return false;
    var root = el.shadowRoot || el;
    var btn = root.querySelector('button.chat-toggle, button[aria-label*="hat" i], [data-chat-toggle], button');
    if (btn) { btn.click(); return true; }
    if (typeof el.click === 'function') { el.click(); return true; }
    return false;
  }
  function sydneyStamp(d) {
    try { return new Intl.DateTimeFormat('en-AU', { timeZone: C.tz, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(d || new Date()); }
    catch (e) { return String(d || new Date()); }
  }
  function backText(s) {
    if (!s || !s.opens) return 'opening time';
    return s.opens + (s.when === 'today' ? ' today' : s.when === 'tomorrow' ? ' tomorrow' : ' ' + s.when);
  }
  function phoneOk(v) { return String(v || '').replace(/\D/g, '').length >= 8; }

  /* ---------- tabs ---------- */
  var tabsEl = $('[data-awh-tabs]'), tabs = $$('[data-awh-tab]'), panes = $$('[data-awh-pane]');
  var voiceMode = false;
  function showTab(name, focus) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-awh-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function (p) { p.hidden = p.getAttribute('data-awh-pane') !== name; });
    dlg.setAttribute('data-tab', name);
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { showTab(t.getAttribute('data-awh-tab')); });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
      e.preventDefault();
      var n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      showTab(tabs[n].getAttribute('data-awh-tab'), true);
    });
  });

  /* ---------- open / close ---------- */
  var opener = null;
  function refreshCopy() {
    var s = H.status();
    $$('[data-awh-back]').forEach(function (el) { el.textContent = backText(s); });
    $$('[data-awh-back-short]').forEach(function (el) { el.textContent = s.opens ? s.opens + (s.whenShort ? ' ' + s.whenShort : '') : 'opening'; });
    var title = $('#AwHoursTitle'), lead = $('#AwHoursLead');
    if (s.open) { /* opened manually while open (e.g. "or email us") */
      title.textContent = 'How can we help?';
      lead.innerHTML = 'We’re open until <b>' + s.closes + '</b> — call <a href="tel:' + C.tel + '" data-aw-skip>' + C.display + '</a>, or send a quick message below.';
    } else {
      title.textContent = 'We’re closed right now';
      lead.innerHTML = 'We’ll be back at <b data-awh-back>' + backText(s) + '</b>. Leave us a message and we’ll call you back first thing.';
    }
    dlg.classList.toggle('is-open-hours', !!s.open);
  }
  function setup() {
    voiceMode = isTouchPhone() && canRecord();
    tabsEl.hidden = !voiceMode;
    if (!voiceMode) { $('[data-awh-pane="voice"]').hidden = true; showTab('write'); }
    else { if (!dlg.getAttribute('data-tab')) showTab('voice'); loadTurnstile(); }
    var chat = $('[data-awh-chat]'); if (chat) chat.hidden = !chatEl();
  }
  function open(from) {
    opener = from || document.activeElement;
    refreshCopy(); setup();
    /* get Shopify's invisible spam check ready now, so the first tap on Send goes straight through */
    try { if (form && !form._awProt && window.Shopify && Shopify.captcha && Shopify.captcha.protect) { Shopify.captcha.protect(form); form._awProt = true; } } catch (e) {}
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
    else dlg.setAttribute('open', '');
    document.documentElement.classList.add('awh-lock');
    var t = $('#AwHoursTitle'); if (t) t.focus({ preventScroll: true });
  }
  function close() {
    if (rec.state === 'recording') stopRec();
    stopPlay();
    if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
  }
  var keepOpen = false; /* set while the sheet swaps from modal to non-modal for Shopify's spam check */
  dlg.addEventListener('close', function () {
    if (keepOpen) { keepOpen = false; return; }
    dlg.classList.remove('is-nm');
    document.documentElement.classList.remove('awh-lock');
    if (rec.state === 'recording') stopRec();
    stopPlay();
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  });
  $$('[data-awh-close]').forEach(function (b) { b.addEventListener('click', close); });
  /* click on the backdrop (the dialog box itself, outside the panel) closes */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  /* while recording, Escape stops the recording first instead of losing it */
  dlg.addEventListener('cancel', function (e) { if (rec.state === 'recording') { e.preventDefault(); stopRec(); } });

  /* ---------- tel: interception ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (!a || a.hasAttribute('data-aw-skip') || e.defaultPrevented) return;
    if (telDigits && String(a.getAttribute('href')).replace(/\D/g, '').slice(-8) !== telDigits) return;
    var s = H.status();
    if (s.open) return; /* open: dial as normal */
    e.preventDefault();
    open(a);
  }, true);
  /* explicit openers anywhere on the site: <button data-aw-hours-open> */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aw-hours-open]');
    if (b) { e.preventDefault(); open(b); }
  });
  document.addEventListener('aw:hours', function () { if (dlg.open) refreshCopy(); });

  /* ---------- chat ---------- */
  var chatBtn = $('[data-awh-chat]');
  if (chatBtn) chatBtn.addEventListener('click', function () { close(); setTimeout(function () { if (!openChat()) chatBtn.hidden = true; }, 60); });

  /* ---------- quick email (native Shopify contact form, sent in place) ---------- */
  var form = document.getElementById('AwHoursContact');
  if (form) {
    form.noValidate = true;
    var reach = $('[data-awh-reach]', form), reachErr = $('[data-awh-reach-err]', form), ferr = $('[data-awh-form-err]', form);
    var hEmail = $('[data-awh-email]', form), hPhone = $('[data-awh-phone]', form), sendBtn = $('[data-awh-send]', form);
    var nameIn = form.querySelector('[name="contact[name]"]'), body = $('[data-awh-body]', form);
    /* the visible textarea is not posted; the composed message goes in a hidden field (so a retry never doubles it) */
    var hBody = document.createElement('input'); hBody.type = 'hidden'; hBody.name = 'contact[body]';
    body.removeAttribute('name'); form.appendChild(hBody);
    /* keyboard: switch to a number pad as soon as it looks like a phone number */
    reach.addEventListener('input', function () {
      var v = reach.value.trim();
      var looksPhone = /^[+\d(][\d\s()+-]*$/.test(v);
      reach.setAttribute('inputmode', looksPhone && v.length ? 'tel' : 'email');
      reachErr.hidden = true; reach.removeAttribute('aria-invalid');
    });
    /* Validate in the capture phase, before Shopify's own CAPTCHA listener on the form: a bad entry never reaches it. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      ferr.hidden = true;
      var v = reach.value.trim(), isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
      if (!isEmail && !phoneOk(v)) {
        e.preventDefault(); e.stopPropagation();
        reachErr.textContent = v ? 'Please enter a phone number (8+ digits) or an email address.' : 'Add a phone number or email so we can reply.';
        reachErr.hidden = false; reach.setAttribute('aria-invalid', 'true'); reach.focus();
        return;
      }
      /* Shopify's contact form needs an email; for a phone-only message the store inbox is the sender and the
         callback number goes at the top of the message. */
      hEmail.value = isEmail ? v : (C.email || '');
      hPhone.value = isEmail ? '' : v;
      var who = (nameIn.value || '').trim(), msg = (body.value || '').trim();
      hBody.value = (isEmail ? '' : 'Please call back on: ' + v + '\n\n') + (msg || '(No message — please get in touch.)') +
        '\n\n— Sent ' + (H.status().open ? '' : 'after hours ') + '(' + sydneyStamp() + ' Sydney time) from ' + location.href.split('?')[0];
      try { sessionStorage.setItem('awh-sent', JSON.stringify({ who: who, t: Date.now() })); } catch (er) {}
      sendBtn.disabled = true; sendBtn.classList.add('is-busy');
      setTimeout(function () { sendBtn.disabled = false; sendBtn.classList.remove('is-busy'); }, 15000);
      /* Shopify's invisible hCaptcha may need to show a challenge: a modal <dialog> would sit above it and make it
         unclickable, so the sheet carries on as a normal (non-modal) layer while the message is sent. */
      try { if (dlg.open && dlg.matches(':modal')) { keepOpen = true; dlg.close(); dlg.show(); dlg.classList.add('is-nm'); } } catch (er) {}
      /* Native submit: Shopify adds its invisible CAPTCHA token, posts, and brings the shopper back here with
         ?contact_posted=true — the sheet then reopens on its success message (below). */
    }, true);
    /* Back from Shopify after sending: reopen the sheet with the result */
    (function () {
      var flag = null;
      try { flag = JSON.parse(sessionStorage.getItem('awh-sent') || 'null'); sessionStorage.removeItem('awh-sent'); } catch (er) {}
      if (!flag || !/[?&]contact_posted=/.test(location.search) || Date.now() - flag.t > 10 * 60 * 1000) return;
      var posted = /[?&]contact_posted=true/.test(location.search) || !!$('[data-awh-posted]');
      var errEl = $('[data-awh-errors]');
      try { if (/contact_posted=/.test(location.search)) history.replaceState(null, '', location.pathname + location.search.replace(/[?&]contact_posted=[^&]*/, '').replace(/^&/, '?') + location.hash.replace('#AwHoursContact', '').replace('#contact_form', '')); } catch (er) {}
      open(null);
      showTab('write');
      if (posted && !errEl) {
        form.hidden = true;
        var done = $('[data-awh-done]'); done.hidden = false;
        var s = H.status();
        $('[data-awh-done-h]').textContent = 'Message sent' + (flag.who ? ', thanks ' + flag.who.split(' ')[0] : ' — thank you') + '!';
        $('[data-awh-done-t]').textContent = s.open ? 'We’ll reply shortly.' : 'We’ll get back to you from ' + backText(s) + '.';
        done.focus();
      } else {
        ferr.innerHTML = 'Sorry, that didn’t send' + (errEl && errEl.textContent.trim() ? ' (' + errEl.textContent.trim() + ')' : '') +
          '. Please try again, or email <a href="mailto:' + (C.email || '') + '">' + (C.email || 'us') + '</a>.';
        ferr.hidden = false;
      }
    })();
  }

  /* ---------- voicemail recorder ---------- */
  var rec = { state: 'idle', mr: null, stream: null, chunks: [], blob: null, url: '', mime: '', started: 0, timer: 0, hard: 0, dur: 0, ctx: null, raf: 0 };
  var vRoot = $('[data-vm-stage]'), recBtn = $('[data-vm-rec]'), ring = $('[data-vm-ring]'), timeEl = $('[data-vm-time]');
  var vH = $('[data-vm-h]'), vSub = $('[data-vm-sub]'), live = $('[data-vm-live]'), btnLabel = $('[data-vm-btnlabel]');
  var playBox = $('[data-vm-playbox]'), playBtn = $('[data-vm-play]'), prog = $('[data-vm-prog]'), durEl = $('[data-vm-dur]');
  var vForm = $('[data-vm-form]'), vErr = $('[data-vm-err]'), vSend = $('[data-vm-send]'), bars = $$('[data-vm-bars] i');

  /* ---------- Cloudflare Turnstile — optional bot protection for the Web3Forms POST (site key: C.turnstile).
     Renders into [data-awh-turnstile]; the token is sent as cf-turnstile-response. When C.turnstile is blank the
     widget never loads and the honeypot (botcheck) is the only check — i.e. nothing changes. ---------- */
  var tsBox = $('[data-awh-turnstile]'), tsId = null, tsBusy = false;
  function tsEnabled() { return !!(C.turnstile && tsBox); }
  function loadTurnstile() {
    if (!tsEnabled() || tsId !== null || tsBusy) return;
    tsBusy = true;
    function renderTs() {
      if (!window.turnstile || tsId !== null) return;
      tsBox.hidden = false;
      try { tsId = window.turnstile.render(tsBox, { sitekey: C.turnstile }); } catch (e) { tsId = null; }
    }
    if (window.turnstile) { renderTs(); return; }
    var existing = document.querySelector('script[data-awh-ts]');
    if (!existing) {
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true; s.defer = true; s.setAttribute('data-awh-ts', '');
      s.onload = renderTs;
      document.head.appendChild(s);
    } else {
      var tries = 0, iv = setInterval(function () { if (window.turnstile || tries++ > 50) { clearInterval(iv); renderTs(); } }, 100);
    }
  }
  function tsToken() {
    if (!tsEnabled() || tsId === null || !window.turnstile) return '';
    try { return window.turnstile.getResponse(tsId) || ''; } catch (e) { return ''; }
  }
  function tsReset() {
    if (tsEnabled() && tsId !== null && window.turnstile) { try { window.turnstile.reset(tsId); } catch (e) {} }
  }

  var CIRC = 2 * Math.PI * 54;
  if (ring) { ring.style.strokeDasharray = CIRC; ring.style.strokeDashoffset = CIRC; }
  var audio = new Audio(); audio.preload = 'auto';

  function stage(s) { rec.state = s; vRoot.setAttribute('data-vm-stage', s); }
  function pickMime() {
    var list = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus', 'audio/aac'];
    for (var i = 0; i < list.length; i++) { try { if (MediaRecorder.isTypeSupported(list[i])) return list[i]; } catch (e) {} }
    return '';
  }
  function ext(m) { return /mp4|aac/.test(m) ? 'm4a' : /ogg/.test(m) ? 'ogg' : 'webm'; }
  function tick() {
    var el = (Date.now() - rec.started) / 1000;
    timeEl.textContent = fmt(MAX - el);
    if (ring) ring.style.strokeDashoffset = CIRC * (1 - Math.min(1, el / MAX));
    var left = MAX - el;
    if (left <= 10.5 && left > 9.5 && !rec.warned) { rec.warned = true; live.textContent = '10 seconds left'; }
    vRoot.classList.toggle('is-ending', left <= 10);
  }
  function meter() {
    if (!rec.analyser) return;
    var arr = new Uint8Array(rec.analyser.frequencyBinCount);
    (function loop() {
      if (rec.state !== 'recording') { bars.forEach(function (b) { b.style.transform = ''; }); return; }
      rec.analyser.getByteFrequencyData(arr);
      var step = Math.floor(arr.length / (bars.length + 2)) || 1;
      bars.forEach(function (b, i) { var v = arr[(i + 1) * step] / 255; b.style.transform = 'scaleY(' + (0.18 + v * 0.95).toFixed(2) + ')'; });
      rec.raf = requestAnimationFrame(loop);
    })();
  }
  function startRec() {
    vErr.hidden = true;
    stage('asking');
    vH.textContent = 'Allow the microphone…'; vSub.textContent = 'Your phone will ask for permission.';
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } }).then(function (stream) {
      rec.stream = stream; rec.chunks = []; rec.warned = false;
      rec.mime = pickMime();
      try { rec.mr = rec.mime ? new MediaRecorder(stream, { mimeType: rec.mime, audioBitsPerSecond: 32000 }) : new MediaRecorder(stream); }
      catch (e) { rec.mr = new MediaRecorder(stream); }
      rec.mime = rec.mr.mimeType || rec.mime || 'audio/webm';
      rec.mr.ondataavailable = function (ev) { if (ev.data && ev.data.size) rec.chunks.push(ev.data); };
      rec.mr.onstop = finishRec;
      rec.mr.start(1000);
      rec.started = Date.now();
      stage('recording');
      vH.textContent = 'Recording… tap to stop'; vSub.textContent = 'Say your name, number and what you need.';
      btnLabel.textContent = 'Stop recording';
      live.textContent = 'Recording started. You have 90 seconds.';
      tick(); rec.timer = setInterval(tick, 250);
      rec.hard = setTimeout(function () { if (rec.state === 'recording') { live.textContent = 'Time’s up — recording stopped.'; stopRec(); } }, MAX * 1000);
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (AC && !reduce) { rec.ctx = new AC(); var src = rec.ctx.createMediaStreamSource(stream); rec.analyser = rec.ctx.createAnalyser(); rec.analyser.fftSize = 64; src.connect(rec.analyser); meter(); }
      } catch (e) {}
    }).catch(function (err) {
      stage('idle');
      vH.textContent = 'Record a message'; vSub.textContent = 'Tap and talk — up to 90 seconds.';
      vErr.innerHTML = (err && err.name === 'NotAllowedError')
        ? 'We couldn’t use your microphone. Allow it in your browser settings, or <button type="button" class="awh__link" data-go-write>write to us instead</button>.'
        : 'Recording isn’t available on this device. Please <button type="button" class="awh__link" data-go-write>write to us instead</button>.';
      vErr.hidden = false; vForm.hidden = false; vForm.querySelector('[name=phone]').closest('.awh__row').hidden = true; vSend.hidden = true;
    });
  }
  function stopRec() {
    clearInterval(rec.timer); clearTimeout(rec.hard); cancelAnimationFrame(rec.raf);
    rec.dur = Math.min(MAX, (Date.now() - rec.started) / 1000);
    if (rec.mr && rec.mr.state !== 'inactive') { try { rec.mr.stop(); } catch (e) { finishRec(); } }
    if (rec.stream) rec.stream.getTracks().forEach(function (t) { t.stop(); });
    if (rec.ctx) { try { rec.ctx.close(); } catch (e) {} rec.ctx = null; rec.analyser = null; }
    stage('processing');
  }
  function finishRec() {
    vRoot.classList.remove('is-ending');
    btnLabel.textContent = 'Record again';
    if (!rec.chunks.length || rec.dur < 1) {
      stage('idle'); vH.textContent = 'That was a bit short'; vSub.textContent = 'Tap the button and talk — up to 90 seconds.';
      timeEl.textContent = fmt(MAX); if (ring) ring.style.strokeDashoffset = CIRC;
      return;
    }
    rec.blob = new Blob(rec.chunks, { type: rec.mime.split(';')[0] });
    if (rec.url) URL.revokeObjectURL(rec.url);
    rec.url = URL.createObjectURL(rec.blob);
    audio.src = rec.url;
    stage('recorded');
    vH.textContent = 'Nice — have a listen'; vSub.textContent = 'Happy with it? Add your number and send.';
    durEl.textContent = fmt(rec.dur); prog.style.transform = 'scaleX(0)';
    playBox.hidden = false; vForm.hidden = false; vSend.hidden = false;
    var row = vForm.querySelector('.awh__row'); if (row) row.hidden = false;
    live.textContent = 'Recorded ' + fmt(rec.dur) + '. You can play it back, re-record, or send it.';
    var ph = vForm.querySelector('[name=phone]'); setTimeout(function () { if (!ph.value) ph.focus({ preventScroll: false }); }, 50);
  }
  function stopPlay() { try { audio.pause(); } catch (e) {} if (playBtn) playBtn.classList.remove('is-playing'); }
  if (recBtn) recBtn.addEventListener('click', function () {
    if (rec.state === 'recording') return stopRec();
    if (rec.state === 'asking' || rec.state === 'processing' || rec.state === 'sending') return;
    stopPlay(); startRec();
  });
  if (playBtn) playBtn.addEventListener('click', function () {
    if (audio.paused) { audio.play().then(function () { playBtn.classList.add('is-playing'); playBtn.setAttribute('aria-label', 'Pause'); }).catch(function () {}); }
    else { stopPlay(); playBtn.setAttribute('aria-label', 'Play your message'); }
  });
  audio.addEventListener('timeupdate', function () {
    var d = isFinite(audio.duration) && audio.duration > 0 ? audio.duration : rec.dur || 1;
    prog.style.transform = 'scaleX(' + Math.min(1, audio.currentTime / d).toFixed(3) + ')';
    durEl.textContent = fmt(audio.currentTime || 0) + ' / ' + fmt(rec.dur);
  });
  audio.addEventListener('ended', function () { playBtn.classList.remove('is-playing'); playBtn.setAttribute('aria-label', 'Play your message'); prog.style.transform = 'scaleX(1)'; durEl.textContent = fmt(rec.dur); });
  var redo = $('[data-vm-redo]');
  if (redo) redo.addEventListener('click', function () {
    stopPlay(); playBox.hidden = true; rec.blob = null;
    timeEl.textContent = fmt(MAX); if (ring) ring.style.strokeDashoffset = CIRC;
    startRec();
  });
  dlg.addEventListener('click', function (e) { if (e.target.closest('[data-go-write]')) { showTab('write', true); } });

  function postW3F(fd) {
    return fetch('https://api.web3forms.com/submit', { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return { success: r.ok, message: 'HTTP ' + r.status }; }); });
  }
  if (vForm) vForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = (vForm.elements.name.value || '').trim(), phone = (vForm.elements.phone.value || '').trim();
    if (!phoneOk(phone)) {
      vErr.textContent = 'Please add the best number to call you back on.'; vErr.hidden = false;
      vForm.elements.phone.setAttribute('aria-invalid', 'true'); vForm.elements.phone.focus(); return;
    }
    if (vForm.elements.botcheck.checked) return;
    var tstok = tsToken();
    if (tsEnabled() && !tstok) {
      vErr.textContent = 'Please wait a moment for the spam check to finish, then tap send again.'; vErr.hidden = false;
      try { tsBox.scrollIntoView({ block: 'center' }); } catch (er) {}
      return;
    }
    vErr.hidden = true; vForm.elements.phone.removeAttribute('aria-invalid');
    stage('sending'); vSend.disabled = true; vSend.classList.add('is-busy');
    var when = sydneyStamp(), who = name || 'A customer';
    var text = who + ' left a ' + fmt(rec.dur) + ' voicemail on the website after hours and would like a call back on ' + phone + '.\n\n' +
      'Recorded: ' + when + ' (Sydney time)\nPage: ' + location.href;
    function base(subject) {
      var fd = new FormData();
      fd.append('access_key', C.w3f);
      fd.append('subject', subject);
      fd.append('from_name', 'Ability Warehouse website');
      fd.append('name', name || 'Not given');
      fd.append('phone', phone);
      fd.append('message', text);
      if (tstok) fd.append('cf-turnstile-response', tstok);
      return fd;
    }
    var withAudio = base('Voicemail from website');
    var file;
    try { file = new File([rec.blob], 'voicemail-' + Date.now() + '.' + ext(rec.mime), { type: rec.blob.type }); }
    catch (er) { file = rec.blob; }
    withAudio.append('attachment', file, 'voicemail-' + Date.now() + '.' + ext(rec.mime));
    postW3F(withAudio)
      .catch(function (err) { return { success: false, message: String(err && err.message || err) }; })
      .then(function (res) {
        if (res && res.success) return { ok: true, audio: true };
        /* Attachment refused (e.g. Web3Forms free plan) or upload failed: send the text so the callback is never lost */
        var fd = base('Voicemail from website (callback request)');
        fd.set('message', text + '\n\n(The audio recording could not be attached' + (res && res.message ? ': ' + res.message : '') + '. Please call back on ' + phone + '.)');
        return postW3F(fd).then(function (r2) { return { ok: !!(r2 && r2.success), audio: false, msg: r2 && r2.message }; });
      })
      .then(function (out) {
        if (!out.ok) throw new Error(out.msg || 'send failed');
        var s = H.status();
        $('[data-vm-done-h]').textContent = 'Got it' + (name ? ', thanks ' + name.split(' ')[0] : ' — thanks') + '!';
        $('[data-vm-done-t]').textContent = 'We’ll call you on ' + phone + (s.open ? ' shortly.' : ' from ' + backText(s) + '.');
        vRoot.hidden = true; var d = $('[data-vm-done]'); d.hidden = false; d.focus();
        stage('sent');
      })
      .catch(function () {
        stage('recorded');
        vErr.innerHTML = 'Sorry, that didn’t send. Check your connection and try again, or <button type="button" class="awh__link" data-go-write>write to us instead</button>.';
        vErr.hidden = false;
      })
      .then(function () { vSend.disabled = false; vSend.classList.remove('is-busy'); tsReset(); });
  });

  window.AWHoursSheet = { open: open, close: close };
})();
